import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CartProvider } from './storefront/state/cart';
import { WishlistProvider } from './storefront/state/wishlist';
import { CustomerAuthProvider } from './storefront/state/customerAuth';
import { ThemeLayout } from './storefront/layout/ThemeLayout';
import { HomePage } from './storefront/pages/HomePage';
import { ShopPage } from './storefront/pages/ShopPage';
import { CategoryPage } from './storefront/pages/CategoryPage';
import { ProductPage } from './storefront/pages/ProductPage';
import { CartPage } from './storefront/pages/CartPage';
import { CheckoutPage } from './storefront/pages/CheckoutPage';
import { AccountPage } from './storefront/pages/AccountPage';
import { CustomerDashboardPage } from './storefront/pages/CustomerDashboardPage';
import { CustomerOrderDetailPage } from './storefront/pages/CustomerOrderDetailPage';
import { PolicyPage } from './storefront/pages/PolicyPage';
import { ContactPage } from './storefront/pages/ContactPage';
import { NotFoundPage } from './storefront/pages/NotFoundPage';
import { WishlistPage } from './storefront/pages/WishlistPage';

function App() {
  return (
    <CartProvider>
      <WishlistProvider>
        <Router>
          <CustomerAuthProvider>
            <Routes>
              <Route element={<ThemeLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/category/:slug" element={<CategoryPage />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/account/dashboard" element={<CustomerDashboardPage />} />
                <Route path="/account/orders/:orderId" element={<CustomerOrderDetailPage />} />
                <Route path="/policy/:type" element={<PolicyPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </CustomerAuthProvider>
        </Router>
      </WishlistProvider>
    </CartProvider>
  );
}

export default App;
